import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  border-style: solid;
  padding: ${RFValue(12)}px;
  border-radius: ${RFValue(14)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  background-color: ${({theme}) => theme.colors.background};
  shadow-color: #000;
  shadow-opacity: 0.06;
  shadow-radius: 8px;
  shadow-offset: 0px 4px;
  elevation: 3;
`;

export const Store = styled.TouchableOpacity``;

export const StoreContent = styled.View`
  flex-direction: row;
  align-items: center;

  justify-content: space-between;
`;

export const StoreColumn = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

export const StoreImage = styled(FastImage)`
  height: ${RFValue(52)}px;
  width: ${RFValue(52)}px;
  background-color: ${({theme}) => theme.colors.shape};
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(14)}px;
`;
export const StoreInfos = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;
export const StoreName = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(13)}px;
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.semibold};
  line-height: ${RFValue(18)}px;
`;
export const StoreDetails = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const StoreAddress = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const StoreDistance = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(11)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Icon = styled(Feather)`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(22)}px;
  margin-left: ${RFValue(6)}px;
`;

export const Footer = styled.View``;

export const StoreMeta = styled.View`
  flex-direction: row;
  align-items: center;
  margin-top: ${RFValue(6)}px;
  flex-wrap: wrap;
`;

export const DistanceBadge = styled.View`
  padding: ${RFValue(4)}px ${RFValue(8)}px;
  background-color: ${({theme}) => theme.colors.primary_light};
  border-radius: ${RFValue(12)}px;
`;

export const AddressText = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(11)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  margin-right: ${RFValue(8)}px;
`;
